module.exports = __webpack_public_path__ + "img/bryce-hospital-logo.73d50d08.jpg";